/* tslint:disable */
/* eslint-disable */
/**
 * Consolidate Legacy API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    GetFollowAktsResponseItems,
    GetFollowAktsResponseItemsFromJSON,
    GetFollowAktsResponseItemsFromJSONTyped,
    GetFollowAktsResponseItemsToJSON,
} from './';

/**
 * 
 * @export
 * @interface GetFollowAktsResponse
 */
export interface GetFollowAktsResponse {
    /**
     * 
     * @type {Array<GetFollowAktsResponseItems>}
     * @memberof GetFollowAktsResponse
     */
    items: Array<GetFollowAktsResponseItems>;
}

export function GetFollowAktsResponseFromJSON(json: any): GetFollowAktsResponse {
    return GetFollowAktsResponseFromJSONTyped(json, false);
}

export function GetFollowAktsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetFollowAktsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(GetFollowAktsResponseItemsFromJSON)),
    };
}

export function GetFollowAktsResponseToJSON(value?: GetFollowAktsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'items': ((value.items as Array<any>).map(GetFollowAktsResponseItemsToJSON)),
    };
}


